/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const es_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const de_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} Min`)
};

const nl_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const fr_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const it_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const pt_br2_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const pt_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

const ja_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}分`)
};

const zh_wc_min = /** @type {(inputs: { minutes: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分钟`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ minutes: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_min = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_min(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_min", locale)
	if (locale === "en") return en_wc_min(inputs)
	if (locale === "es") return es_wc_min(inputs)
	if (locale === "de") return de_wc_min(inputs)
	if (locale === "nl") return nl_wc_min(inputs)
	if (locale === "fr") return fr_wc_min(inputs)
	if (locale === "it") return it_wc_min(inputs)
	if (locale === "pt-BR") return pt_br2_wc_min(inputs)
	if (locale === "pt") return pt_wc_min(inputs)
	if (locale === "ja") return ja_wc_min(inputs)
	return zh_wc_min(inputs)
};